/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Brand domain (bring-your-own-domain) models mirrored from
 * `@product-passport/organization/dto`.
 */

export type BrandDomainLogoMode = 'UPLOAD' | 'NONE' | 'REFERENCE';

export interface BrandDomainLogo {
  mode: BrandDomainLogoMode;
  /** `data:image/png;base64,…` or `data:image/svg+xml;base64,…` when `mode === 'UPLOAD'`. */
  url?: string;
  /** Id of the brand domain whose uploaded logo is reused when `mode === 'REFERENCE'`. */
  refDomainId?: string;
}

export interface BrandDomain {
  id: string;
  host: string;
  rootDomain: string;
  label?: string;
  isDefault: boolean;
  logo: BrandDomainLogo;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateBrandDomain {
  host: string;
  label?: string;
  isDefault?: boolean;
  logo?: BrandDomainLogo;
}

export type UpdateBrandDomain = Partial<Omit<CreateBrandDomain, 'host'>>;

/**
 * Branding returned with public passports for the scan page. Absent when the organisation
 * has no brand domains (platform default); `logoUrl: null` renders a neutral page.
 */
export interface PassportBranding {
  logoUrl: string | null;
}

/** Logo constraints are owned by the shared util lib so backend and UI never drift. */
export {
  BRAND_LOGO_ACCEPTED_TYPES,
  BRAND_LOGO_MAX_BYTES,
  BRAND_LOGO_MIN_HEIGHT_PX,
} from '@product-passport/organization/util';
